import { Report } from '@idea2app/ai-work-order-service';
import { Icon } from 'idea-react';
import { FC } from 'react';
import { Button, Card, Col, Form, FormProps, Row } from 'react-bootstrap';

import { t } from '../model/Translation';

export interface ReportCreationFormProps
    extends Partial<Report>, Omit<FormProps, 'id' | 'name'> {
    selectedTemplate?: string;
}

export const ReportCreationForm: FC<ReportCreationFormProps> = ({
    id,
    name,
    startDate,
    endDate,
    selectedTemplate,
    ...props
}) => (
    <Form {...props}>
        <h6 className="mb-3">基本信息</h6>

        <Row className="mb-3" xs={1} md={2}>
            <Form.Group className="col">
                <Form.Label>{t('report_name')}</Form.Label>
                <Form.Control
                    name="name"
                    placeholder={t('enter_task_name')}
                    defaultValue={name}
                />
            </Form.Group>

            <Form.Group className="col">
                <Form.Label>{t('time_range')}</Form.Label>
                <div className="d-flex align-items-center gap-2">
                    <Form.Control
                        type="date"
                        name="startDate"
                        defaultValue={startDate}
                    />
                    <span>至</span>
                    <Form.Control
                        type="date"
                        name="endDate"
                        defaultValue={endDate}
                    />
                </div>
            </Form.Group>
        </Row>

        <h6 className="mb-3">{t('select_template')}</h6>
        <Row className="mb-3 g-3">
            {[
                {
                    id: 'quality_service_weekly',
                    icon: 'clipboard-data',
                    title: t('quality_service_weekly'),
                    description: `${t('all_business_control')} ${t('quality_service')}`
                },
                {
                    id: 'power_service_issues',
                    icon: 'exclamation-circle',
                    title: t('power_service_issues'),
                    description: `${t('all_business_control')} ${t('quality_service')}`
                },
                {
                    id: 'annual_summary',
                    icon: 'calendar-check',
                    title: t('annual_summary'),
                    description: '基于全年工单数据分析，指导服务策略与流程优化'
                }
            ].map(template => (
                <Col key={template.id} md={4}>
                    <Card
                        as="label"
                        className={`h-100 cursor-pointer ${selectedTemplate === template.id ? 'border-primary' : ''}`}
                        body
                    >
                        <div className="d-flex align-items-center justify-content-between mb-2">
                            <Icon name={template.icon} />
                            <Form.Check
                                type="radio"
                                name="template"
                                checked={selectedTemplate === template.id}
                                readOnly
                            />
                        </div>
                        <div className="fw-bold mb-1">{template.title}</div>
                        <small className="text-muted">
                            {template.description}
                        </small>
                    </Card>
                </Col>
            ))}
        </Row>

        <Card className="bg-primary bg-opacity-10 mb-3" body>
            <div className="d-flex align-items-start gap-2">
                <div className="bg-primary rounded px-3 py-2">
                    <Icon name="robot" size={2} className="text-white" />
                </div>
                <div className="flex-grow-1 pt-2">
                    <h6>{t('ai_suggestion')}</h6>
                    <p className="text-muted mb-2">{t('based_on_history')}</p>
                    <div className="d-flex flex-column gap-2">
                        <div className="d-flex align-items-start gap-2">
                            <Icon
                                name="exclamation-circle"
                                className="text-danger mt-1"
                            />
                            <span>{t('duplicate_rate_increase')}</span>
                        </div>
                        <div className="d-flex align-items-start gap-2">
                            <Icon
                                name="exclamation-triangle"
                                className="text-warning mt-1"
                            />
                            <span>{t('night_failure_low')}</span>
                        </div>
                    </div>
                </div>
            </div>
        </Card>

        <footer className="border-top pt-3 d-flex align-items-center gap-2">
            <span className="flex-fill text-muted">
                <Icon name="clock-fill" className="me-2" />
                {t('time_range_has_orders')}
            </span>
            <Button type="reset" variant="secondary">
                {t('cancel')}
            </Button>
            <Button type="submit" variant="primary">
                {t('start_analysis')}
            </Button>
        </footer>
    </Form>
);
